import React, { useState } from "react";
import PropTypes from "prop-types";
import { NavLink, Routes, Route } from "react-router-dom"; // Removed BrowserRouter
import DashboardHome from "../DashboardHome/DashboardHome";
import useAuth from "../../../hooks/useAuth";
import MakeAdmin from "../MakeAdmin/MakeAdmin";
import ManageProducts from "../ManageProducts/ManageProducts";
import ManageOrder from "../ManageOrder/ManageOrder";
import AddProduct from "../AddProduct/AddProduct";
import Review from "../Review/Review";
import Payment from "../Payment/Payment";
import MyBooking from "../MyBooking/MyBooking";

function DashboardPage() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { admin, user, logout } = useAuth();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div className="h-full bg-slate-900 text-white flex flex-col w-72 shadow-2xl border-r border-slate-800">
      <div className="p-8 pb-4">
        <h2 className="text-2xl font-bold flex items-center gap-3">
          <span className="text-3xl bg-amber-400 text-slate-900 w-10 h-10 rounded-xl flex items-center justify-center shadow-lg shadow-amber-400/20">🐾</span>
          PetHouse
        </h2>
        <p className="text-slate-400 text-sm mt-2 font-medium">Dashboard</p>
      </div>
      
      <div className="flex-1 overflow-y-auto px-4 py-6">
        <nav>
          <ul className="space-y-2">
            <li>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive
                    ? "flex items-center gap-3 px-4 py-3 rounded-xl bg-amber-400/10 text-amber-500 font-semibold"
                    : "flex items-center gap-3 px-4 py-3 rounded-xl text-slate-300 hover:bg-white/5 hover:text-white transition-colors"
                }
              >
                Home
              </NavLink>
            </li>
            <div className="h-px bg-slate-800 my-4 mx-4"></div>
            {admin ? (
              <>
                <li className="px-4 py-2 text-xs font-bold text-slate-500 uppercase tracking-wider">Admin Tools</li>
                <li>
                  <NavLink
                    to="/dashboard/makeAdmin"
                    className={({ isActive }) =>
                      isActive
                        ? "flex items-center gap-3 px-4 py-3 rounded-xl bg-amber-400/10 text-amber-500 font-semibold"
                        : "flex items-center gap-3 px-4 py-3 rounded-xl text-slate-300 hover:bg-white/5 hover:text-white transition-colors"
                    }
                  >
                    Make Admin
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/dashboard/manageProducts"
                    className={({ isActive }) =>
                      isActive
                        ? "flex items-center gap-3 px-4 py-3 rounded-xl bg-amber-400/10 text-amber-500 font-semibold"
                        : "flex items-center gap-3 px-4 py-3 rounded-xl text-slate-300 hover:bg-white/5 hover:text-white transition-colors"
                    }
                  >
                    Manage Products
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/dashboard/manageOrder"
                    className={({ isActive }) =>
                      isActive
                        ? "flex items-center gap-3 px-4 py-3 rounded-xl bg-amber-400/10 text-amber-500 font-semibold"
                        : "flex items-center gap-3 px-4 py-3 rounded-xl text-slate-300 hover:bg-white/5 hover:text-white transition-colors"
                    }
                  >
                    Manage Orders
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/dashboard/addProduct"
                    className={({ isActive }) =>
                      isActive
                        ? "flex items-center gap-3 px-4 py-3 rounded-xl bg-amber-400/10 text-amber-500 font-semibold"
                        : "flex items-center gap-3 px-4 py-3 rounded-xl text-slate-300 hover:bg-white/5 hover:text-white transition-colors"
                    }
                  >
                    Add Product
                  </NavLink>
                </li>
              </>
            ) : (
              <>
                <li className="px-4 py-2 text-xs font-bold text-slate-500 uppercase tracking-wider">My Account</li>
                <li>
                  <NavLink
                    to="/dashboard/myBooking"
                    className={({ isActive }) =>
                      isActive
                        ? "flex items-center gap-3 px-4 py-3 rounded-xl bg-amber-400/10 text-amber-500 font-semibold"
                        : "flex items-center gap-3 px-4 py-3 rounded-xl text-slate-300 hover:bg-white/5 hover:text-white transition-colors"
                    }
                  >
                    My Bookings
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/dashboard/review"
                    className={({ isActive }) =>
                      isActive
                        ? "flex items-center gap-3 px-4 py-3 rounded-xl bg-amber-400/10 text-amber-500 font-semibold"
                        : "flex items-center gap-3 px-4 py-3 rounded-xl text-slate-300 hover:bg-white/5 hover:text-white transition-colors"
                    }
                  >
                    Add Review
                  </NavLink>
                </li>
              </>
            )}
            
            <div className="h-px bg-slate-800 my-4 mx-4"></div>
            {user?.email && (
              <li>
                <button
                  onClick={logout}
                  className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-red-400 hover:bg-red-400/10 hover:text-red-300 transition-colors font-medium text-left mt-auto"
                >
                  Logout
                </button>
              </li>
            )}
          </ul>
        </nav>
      </div>
      
      {/* Mobile close button */}
      <button 
        className="lg:hidden absolute top-6 right-6 text-slate-400 hover:text-white"
        onClick={handleDrawerToggle}
      >
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );

  return (
    <div className="flex h-screen bg-slate-50 font-sans">
      {/* Mobile backdrop */}
      {mobileOpen && (
        <div 
          className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-40 lg:hidden transition-opacity"
          onClick={handleDrawerToggle}
        />
      )}

      {/* Sidebar Drawer */}
      <div
        className={`fixed inset-y-0 left-0 z-50 lg:relative lg:translate-x-0 ${
          mobileOpen ? "translate-x-0" : "-translate-x-full"
        } transform transition-transform duration-300 ease-in-out`}
      >
        {drawer}
      </div>

      {/* Content Area */}
      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        {/* Top Header for mobile toggle & user info */}
        <header className="bg-white border-b border-gray-100 flex items-center justify-between px-6 py-4 lg:hidden">
          <div className="flex items-center gap-3">
            <button 
              onClick={handleDrawerToggle}
              className="p-2 -ml-2 text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <span className="font-bold text-slate-900">PetHouse</span>
          </div>
          {user?.displayName && (
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center font-bold text-sm">
                {user.displayName.charAt(0)}
              </div>
            </div>
          )}
        </header>

        {/* Main Content Router View */}
        <main className="flex-1 overflow-y-auto p-4 md:p-8 lg:p-10">
          <div className="max-w-6xl mx-auto h-full">
            <Routes>
              <Route index element={<DashboardHome />} />
              <Route path="makeAdmin" element={<MakeAdmin />} />
              <Route path="manageProducts" element={<ManageProducts />} />
              <Route path="manageOrder" element={<ManageOrder />} />
              <Route path="addProduct" element={<AddProduct />} />
              <Route path="myBooking" element={<MyBooking />} />
              <Route path="review" element={<Review />} />
              <Route path="payment" element={<Payment />} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  );
}

DashboardPage.propTypes = {
  window: PropTypes.func,
};

export default DashboardPage;
